// extracted by mini-css-extract-plugin
module.exports = {"card":"antdCard_card__W75H3"};